import { EventDetail } from 'libs/api'

export function getSubjectName(event: EventDetail) {
  return `${event.subject.first_name} ${event.subject.last_name}`
}
